export default "__VITE_ASSET__BBngW1BV__"